import DesCatalogNavigationViewModel from 'viewmodel/DesCatalogNavigationViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogNavigation extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogNavigationViewModel);
    }

    get contentPath() {
        return this.getAttribute('contentpath') || this.getAttribute(DesAccConstants.CONTENT_PATH);
    }

    get filterStatus() {
        return this.getAttribute(DesAccConstants.FILTERSTATUS);
    }
    get crumb() {
        return this.getAttribute('crumb');
    }

    get id() {
        return this.getAttribute('id');
    }

    get tablename() {
        return this.getAttribute(DesAccConstants.TABLE_NAME);
    }

    get expansionstate() {
        return this.getAttribute(DesAccConstants.EXPANSION_STATE);
    }

    get navigationType() {
        const type = this.getAttribute(DesAccConstants.NAVIGATION_TYPE);
        switch (type) {
            case DesAccConstants.CATALOG:
                return DesAccConstants.DEFAULT
            case DesAccConstants.STANDARDS:
                return DesAccConstants.STDS
            case DesAccConstants.CATEGORIES:
                return DesAccConstants.FUNC
            default:
                return DesAccConstants.DEFAULT
        }
    }

    get filterUnit() {
        return this.getAttribute(DesAccConstants.FILTER_UNIT);
    }

    getProps() {
        return {
            catalogspaceid: this.catalogspaceId,
            contentpath: this.contentPath,
            hideelements: this.hideElements,
            provider: this.provider,
            filterStatus: this.filterStatus,
            crumb: this.crumb,
            tablename: this.tablename,
            id: this.id,
            expansionstate: this.expansionstate,
            navigationtype: this.navigationType,
            filterunit: this.filterUnit,
            locale: this.locale
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, DesAccConstants.HIDE_ELEMENTS, 'contentpath', DesAccConstants.FILTERSTATUS,
        DesAccConstants.CONTENT_PATH, DesAccConstants.TABLE_NAME, 'id', DesAccConstants.EXPANSION_STATE, DesAccConstants.NAVIGATION_TYPE, DesAccConstants.FILTER_UNIT];
    }
}

if (!window.customElements.get('des-catalog-navigation')) {
    window.customElements.define('des-catalog-navigation', DesCatalogNavigation);
}
